import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate, Button, showNotification, refreshView as refreshViewAction } from 'react-admin';
import compose from 'recompose/compose';

import request from '../../../../network/request';
import resourceConfig from './config';

class LoadAllGoodsButton extends Component {
  state = {
    executing: false,
  };
  handleClick = async () => {
    const { showNotification, refreshView } = this.props;

    this.setState({
      executing: true,
    });
    let response = null;
    try {
      response = await request({
        apiService: 'shoes',
        path: `/admin/nkgoods/func/load`,
        method: 'POST',
      });
    } catch (e) {
      console.error(e);
    }
    if (response === null || !response.ok) {
      showNotification(`resources.${resourceConfig.name}.load.errorMessage`, 'error');
    } else {
      showNotification(`resources.${resourceConfig.name}.load.successMessage`, 'success');
    }

    this.setState(
      {
        executing: false,
      },
      refreshView,
    );
  };

  render() {
    return (
      <Button
        label={`resources.${resourceConfig.name}.load.action`}
        disabled={this.state.executing}
        onClick={this.handleClick}
      />
    );
  }
}

export default compose(
  translate,
  connect(undefined, {
    showNotification,
    refreshView: refreshViewAction,
  }),
)(LoadAllGoodsButton);
